const APPLYLOANS = "/loan/apply-loan";
const BANKCONSENTS = "/banking/consents";
const CREATE_CONTACT = "/contact";
const SEARCH_ORGANIZATION = "/creditsafe/search";
const GET_ORGANIZATION_INFO = "/creditsafe";
const START_ENABLE_BANKING_CONSENT = "/banking/consents";
const GET_BANK_ACCOUNT_NUMBERS = "/banking/getbankaccount";
const GET_BANK_LIST = "/banking/banks";
const STEP_3 = "/loan/step-3";
const APPLICATION_DETAILS = "/loan";

export default {
  APPLYLOANS,
  BANKCONSENTS,
  CREATE_CONTACT,
  SEARCH_ORGANIZATION,
  GET_ORGANIZATION_INFO,
  START_ENABLE_BANKING_CONSENT,
  GET_BANK_ACCOUNT_NUMBERS,
  GET_BANK_LIST,
  STEP_3,
  APPLICATION_DETAILS
};
